import * as React from 'react';
import { connect } from 'react-redux';
import { addToFavorites, removeFromFavorites } from '../../actions/favoritesPageActions';
import {
    clearFilterParams,
    doNewSearchViaUrl,
    setFilterParam,
    newFacetsSearch,
} from '../../actions/searchActions';
import { getLivePositionData } from '../../actions/shipLivePositionAction';
import { loadMoreUGCReviews, setReviewSorting } from '../../actions/ugcAction';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { CabinsSection } from '../../components/CabinsSection/CabinsSection';
import { CollapsibleDropDown } from '../../components/CollapsibleDropDown/CollapsibleDropDown';
import { CollapsibleDropDownTitle } from '../../components/CollapsibleDropDown/CollapsibleDropDownTitle';
import { CollapsibleText } from '../../components/CollapsibleDropDown/CollapsibleText';
import RecommendationZones from '../../components/RecommendationZones/RecommendationZones';
import { MarketContext } from '../../context/markets';
import { Decks } from '../../components/Decks/Decks';
import ReviewsDesktop from '../../components/DesktopReviews/DesktopReviews';
import { DynamicForm } from '../../components/DynamicForm/DynamicForm';
import { FurtherInfo } from '../../components/FurtherInfo/FurtherInfo';
import { GallerySliderSection } from '../../components/GallerySection';
import { CabinIcon } from '../../components/Icons/CabinIcon';
import { ImagesIcon } from '../../components/Icons/ImagesIcon';
import { InfoIcon } from '../../components/Icons/InfoIcon';
import { ListIcon } from '../../components/Icons/ListIcon';
import { LocationIcon } from '../../components/Icons/LocationIcon';
import { StarIcon } from '../../components/Icons/StarIcon';
import { NavigationPanel, Section } from '../../components/NavigationPanel';
import { cruiseList } from '../../components/Recommendation/recommendation';
import RecommendationSection from '../../components/Recommendation/RecommendationSection';
import { SearchMask } from '../../components/SearchFilters/SearchMask';
import { SearchSection } from '../../components/SearchFilters/SearchSection';
import { ShipInputSelection } from '../../components/SearchFilters/ShipInputSelection';
import { ShipPosition } from '../../components/ShipPosition/ShipPosition';
import { TeaserSlider } from '../../components/TeaserSlider';
import { TrackComponent } from '../../components/TrackComponent';
import * as Color from '../../consts/variables';
import {
    getFilter,
    setFilter,
    setFilterArray,
    transformOptions,
} from '../../helpers/searchHelpers';
import { __ } from '../../helpers/TranslationService';
import { IShipDetailPageData } from '../../interfaces/IShipDetailPageData';
import { IShipLivePositionPageReducer } from '../../interfaces/IShipLivePosition';
import { IUGCReviewsReducer } from '../../interfaces/IUGCReviews';
import { ICruiseReducer } from '../../interfaces';
import { IState } from '../../reducers';
import { IPageDataReducer } from '../../reducers/pageData';
import { IRouterReducer } from '../../reducers/router';
import { ISearchReducer } from '../../reducers/search';
import { ShipFacts as ShipFactsComponent } from './components/ShipFacts';
import { Feature } from '@paralleldrive/react-feature-toggles';
import { ShipPositionInfo } from '../../components/ShipPosition/ShipPositionInfo';
import { numberFormatter } from '../../helpers/TranslationService';

import loadable from '@loadable/component';
import { PromoBannerWrapper } from '../Landing/LandingPage';
import { PromoBanner } from '../../components/PromoBanner/PromoBanner';

const MapboxMap = loadable(() => import('../Cruise/components/MapboxMap'), {
    ssr: false,
});

interface StateProps {
    shipPage: IShipDetailPageData;
    cruisePage: ICruiseReducer;
    shipPosition: IShipLivePositionPageReducer;
    pageData: IPageDataReducer;
    search: ISearchReducer;
    router: IRouterReducer;
    favorites: number[];
    reviewsData: IUGCReviewsReducer;
}

type Props = StateProps & typeof mapDispatchToProps;

export class ShipPageClass extends React.Component<Props, any> {
    private title;
    static contextType = MarketContext;
    constructor(props) {
        super(props);
        this.title = props.shipPage.title;
    }
    componentDidMount() {
        this.props.newFacetsSearch();
        this.props.clearFilterParams(false);
        setFilter('ship', this)(this.props.shipPage.shipId);

        if (this.props.shipPage.showLivePosition) {
            this.props.getLivePositionData(this.props.router.params.shipName);
        }
    }

    filterDefaults = {
        departureMax: null,
        dateMin: null,
        zone: 'default',
        ship: this.props.shipPage.shipId,
    };

    render() {
        const { shipPage, shipPosition, pageData, reviewsData } = this.props;
        const { shipOverview, seo, promoBanner } = shipPage;
        const { reviews, sortString, isLoading } = reviewsData;
        const { isCruise1st } = this.context.markets;

        const isDesktop = pageData.deviceType === 'desktop';

        const description = shipOverview.description;

        const { departureMax, dateMin, zone, ship } = getFilter(
            this.props.search,
            this.filterDefaults,
        );

        const numResults = this.props.search.searchFacets.numResults;
        const disableSearchButton = numResults ? false : true;
        const loadingSearchButton = !numResults && numResults !== 0;

        const filterInputProps = {
            search: this.props.search,
            ship: ship.toString(),
            zone,
            transformOptions: transformOptions,
            onShipChange: setFilter('ship', this),
            onZoneChange: setFilter('zone', this),
            numResults: Number.isInteger(numResults) ? numberFormatter().format(numResults) : '',
        };

        const searchMaskInputProps = {
            departureMax,
            dateMin,
            onDateMinChange: setFilter('dateMin', this),
            onDateMaxChange: setFilter('departureMax', this),
            sticky: false,
            isLoading: loadingSearchButton,
            isDisabled: disableSearchButton,
            doNewSearchViaUrl: this.props.doNewSearchViaUrl,
            showSearchBtn: true,
            onDateChange: setFilterArray(['dateMin', 'departureMax'], this),
            languageCode: this.props.pageData.appConfig.languageCode,
            countryCode: this.props.pageData.appConfig.countryCode,
            headline: this.title,
            title:
                (Number.isInteger(numResults) ? numberFormatter().format(numResults) + ' ' : '') +
                __('Search cruise', 'dreamlines'),
        };
        const offerUrl = `/${
            pageData.brandConfig.slugsObj.searchresults
        }?filterParams[ship][0]=${ship.toString()}`;

        // @TODO: Modify CollapsibleDropDown to handle this via css instead of JS ternaries

        const navigationItems: Section[] = isDesktop
            ? ['overview', 'offers', 'reviews', 'cabins', 'position']
            : ['offers', 'overview', 'reviews', 'cabins', 'position'];

        const Description = () => {
            if (!description || isDesktop) return null;
            return <CollapsibleText text={description} />;
        };

        const ShipFacts = () => {
            const title = `${__('Facts & Figures', 'dreamlines')} - ${this.title}`;
            const Component = () => (
                <ShipFactsComponent {...shipOverview} portalId={pageData.appConfig.portalId} />
            );

            const factTitle = (
                <CollapsibleDropDownTitle title={title}>
                    <ListIcon className="icon" />
                </CollapsibleDropDownTitle>
            );
            const FactSection = TrackComponent(CollapsibleDropDown, {
                category: 'mobile-shippage',
                action: 'navigation',
                label: 'facts',
            });

            return !isDesktop ? (
                <FactSection title={factTitle}>
                    <Component />
                </FactSection>
            ) : (
                <>
                    <h2 className="headline" dangerouslySetInnerHTML={{ __html: title }} />
                    <Component />
                </>
            );
        };

        const Impressions = () => {
            const teaserData = shipOverview.images.map((teaser) => ({
                imageUrl: teaser,
            }));
            const title = isDesktop
                ? __('Cruises with %s (ship page)', 'dreamlines', this.title)
                : `${this.title} - ${__('Ship impression', 'dreamlines')}`;

            const impressionTitle = (
                <CollapsibleDropDownTitle title={title}>
                    <ImagesIcon className="icon" />
                </CollapsibleDropDownTitle>
            );
            const ImpressionSection = TrackComponent(CollapsibleDropDown, {
                category: 'mobile-shippage',
                action: 'navigation',
                label: 'impressions',
            });

            return !isDesktop ? (
                <ImpressionSection title={impressionTitle}>
                    <TeaserSlider teaserData={teaserData} />
                </ImpressionSection>
            ) : (
                <GallerySliderSection
                    offerUrl={offerUrl}
                    headline={title}
                    content={shipPage.shipOverview.description}
                    galleryImages={teaserData.map(({ imageUrl }) => imageUrl)}
                />
            );
        };

        const Cabins = () => {
            const title = `${__('Decks and Cabins', 'dreamlines')} - ${this.title}`;
            const deckTitle = `${__('Please select a deck', 'dreamlines')}`;

            const cabinSectionsProps = {
                router: this.props.router,
                cabins: this.props.shipPage.cabins,
                cruisePage: this.props.cruisePage,
                sailNid: -1,
                currency: this.props.pageData.brandConfig.defaultCurrency,
                isPriceShown: false,
                isCabinSelectShown: true,
                isDesktop,
            };

            const cabinTitle = (
                <CollapsibleDropDownTitle title={title}>
                    <CabinIcon className="icon" />
                </CollapsibleDropDownTitle>
            );
            const CabinSection = TrackComponent(CollapsibleDropDown, {
                category: 'mobile-shippage',
                action: 'navigation',
                label: 'decks & cabins',
            });

            const separatorStyles: React.CSSProperties = {
                borderTop: `1px solid ${Color.gray}`,
                margin: '20px 0',
            };

            return !isDesktop ? (
                <CabinSection title={cabinTitle}>
                    <CabinsSection {...cabinSectionsProps} learnMoreMode />
                    <Decks decks={shipPage.decks} />
                </CabinSection>
            ) : (
                <>
                    <h2
                        className="headline h-desktop"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <div>
                        <CabinsSection {...cabinSectionsProps} />
                        <div style={separatorStyles} />
                        <Decks decks={shipPage.decks} title={deckTitle} />
                    </div>
                </>
            );
        };

        const ShipPositionInformation = () => (
            <div className="shipPosition">
                <ShipPositionInfo position={shipPosition.shipPosition} />
            </div>
        );

        const Position = () => {
            if (!shipPage.showLivePosition) return null;
            const title = `${__('Live Location', 'dreamlines')} - ${this.title}`;

            const positionTitle = (
                <CollapsibleDropDownTitle title={title}>
                    <LocationIcon className="icon" />
                </CollapsibleDropDownTitle>
            );
            const PositionSection = TrackComponent(CollapsibleDropDown, {
                category: 'mobile-shippage',
                action: 'navigation',
                label: 'live position',
            });

            return !isDesktop ? (
                <PositionSection title={positionTitle}>
                    <>
                        <ShipPosition
                            shipTitle={shipPage.title}
                            showLivePosition={shipPage.showLivePosition}
                            showMapOnly={true}
                            position={shipPosition}
                        />
                    </>
                </PositionSection>
            ) : (
                <>
                    <h2 className="headline h-desktop">{title}</h2>
                    <div>
                        <MapboxMap
                            pageType="ship"
                            position={shipPosition.shipPosition}
                            countryCode="de"
                            title={title}
                            markerMode="position"
                        />

                        {/* Working around Link weird styling */}
                        <div>
                            <ShipPositionInformation />
                        </div>
                    </div>
                </>
            );
        };

        const Reviews = () => {
            if (!reviews?.rating?.meta?.total) {
                return null;
            }

            const reviewsProps = {
                reviews: reviews,
                offers: this.props.shipPage.offers,
                priceCurrency: this.props.pageData.appConfig.defaultCurrency,
                loadMoreReviews: this.props.loadMoreUGCReviews,
                setSortString: this.props.setReviewSorting,
                sortString: sortString,
                filterParams: `filterParams[shipNid]=${this.props.shipPage.shipId}`,
                areReviewsLoading: isLoading,
                googleScriptName: this.title,
            };
            const title = __('Reviwes for %s', 'dreamlines', this.title);
            const reviewsTitle = (
                <CollapsibleDropDownTitle title={title}>
                    <StarIcon className="icon iconTransparent" />
                </CollapsibleDropDownTitle>
            );

            return !isDesktop ? (
                <CollapsibleDropDown title={reviewsTitle}>
                    <ReviewsDesktop
                        {...reviewsProps}
                        reviewsType="shipReviews"
                        shipTitle={shipPage.shipTitle}
                        googleScriptName={this.title}
                        isLoading={this.props.reviewsData.isLoading}
                    />
                </CollapsibleDropDown>
            ) : (
                <>
                    <h2 className="headline" id="reviews">
                        {title}
                    </h2>
                    <ReviewsDesktop
                        {...reviewsProps}
                        reviewsType="shipReviews"
                        shipTitle={shipPage.shipTitle}
                        googleScriptName={this.title}
                        isLoading={this.props.reviewsData.isLoading}
                    />
                </>
            );
        };

        const MoreInfo = () => {
            if (!seo.text) return null;
            const title = __('Travel Tips for %s', 'dreamlines', this.title);
            const infoTitle = (
                <CollapsibleDropDownTitle
                    title={title}
                    isSeoTitle={true}
                    titleStyles={{
                        fontSize: '16px',
                        marginTop: '0px',
                        marginBottom: '0px',
                        fontWeight: 'normal',
                    }}
                >
                    <InfoIcon className="icon iconTransparent" />
                </CollapsibleDropDownTitle>
            );
            const InfoSection = TrackComponent(CollapsibleDropDown, {
                category: 'mobile-shippage',
                action: 'navigation',
                label: 'more info',
            });

            return !isDesktop ? (
                <InfoSection title={infoTitle}>
                    <FurtherInfo description={seo.text} />
                </InfoSection>
            ) : (
                <>
                    <h2 className="headline">{title}</h2>
                    <FurtherInfo description={seo.text} />
                </>
            );
        };

        const teaserTracking = { category: 'mobile-teaser-shippage', label: 'ship' };
        const recommendationProps = {
            pageData: this.props.pageData,
            cruiseRecommendations: this.props.shipPage.cruiseRecommendations,
            trackingData: teaserTracking,
            discountThreshold: this.props.pageData.discountThreshold,
        };

        const recommendationTitle = __('%s Cruises', 'dreamlines', this.title);
        const hasZoneRecommendations = shipPage?.zoneTabs?.length > 0 && isCruise1st;

        return (
            <>
                <SearchSection
                    backgroundImage={shipPage.banner.image}
                    headline={shipPage.banner.headline}
                    subHeadline={shipPage.banner.subline}
                >
                    <SearchMask {...searchMaskInputProps} pageData={this.props.pageData}>
                        <ShipInputSelection {...filterInputProps} />
                    </SearchMask>
                </SearchSection>
                <div className="shipPageContainer container">
                    {promoBanner && (
                        <div className="row">
                            <PromoBannerWrapper>
                                <PromoBanner
                                    title={promoBanner.title}
                                    description={promoBanner.description}
                                    subTitle={promoBanner?.subTitle}
                                    imageUrl={promoBanner?.imageUrl}
                                    buttonText={promoBanner?.button?.text}
                                    buttonUrl={promoBanner?.button?.url}
                                />
                            </PromoBannerWrapper>
                        </div>
                    )}

                    <Breadcrumbs
                        className="onlyTabletUp"
                        breadcrumbs={this.props.shipPage.breadcrumbs}
                    />
                    {!isCruise1st && (
                        <NavigationPanel sections={navigationItems} offerUrl={offerUrl} />
                    )}

                    {hasZoneRecommendations ? (
                        <div className="recommendation-section">
                            <RecommendationZones
                                title={__('Our Best %s Deals', 'dreamlines', shipPage.title)}
                                data={shipPage?.zoneTabs}
                            />
                        </div>
                    ) : (
                        isCruise1st && (
                            <RecommendationSection
                                data={cruiseList(recommendationProps)}
                                title={recommendationTitle}
                                favorites={this.props.favorites}
                                addToFavorites={this.props.addToFavorites}
                                removeFromFavorites={this.props.removeFromFavorites}
                                offerUrl={offerUrl}
                            />
                        )
                    )}
                    {!isDesktop && <DynamicForm className="dynamicForm" headline={this.title} />}
                    {!isCruise1st && (
                        <RecommendationSection
                            data={cruiseList(recommendationProps)}
                            title={recommendationTitle}
                            favorites={this.props.favorites}
                            addToFavorites={this.props.addToFavorites}
                            removeFromFavorites={this.props.removeFromFavorites}
                            offerUrl={offerUrl}
                        />
                    )}
                    {isDesktop && (
                        <>
                            <Impressions />
                            <DynamicForm className="dynamicForm" headline={this.title} />
                            <ShipFacts />
                        </>
                    )}
                    {!isDesktop && (
                        <>
                            <Description />
                            <ShipFacts />
                            <Impressions />
                        </>
                    )}
                    <div id="cabins">
                        <Cabins />
                    </div>
                    <div id="position">
                        <Position />
                    </div>
                    <MoreInfo />
                    <Feature
                        name="showReviews"
                        activeComponent={() => (
                            <>
                                <Reviews />
                            </>
                        )}
                    />
                    <Breadcrumbs
                        className="onlyMobile"
                        breadcrumbs={this.props.shipPage.breadcrumbs}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IState): StateProps => ({
    shipPage: state.shipData.shipPage,
    cruisePage: state.cruisePage,
    pageData: state.pageData,
    shipPosition: state.shipLivePositionPage,
    search: state.search,
    favorites: state.favoritePage.favorites,
    router: state.router,
    reviewsData: state.reviews,
});

const mapDispatchToProps = {
    doNewSearchViaUrl,
    clearFilterParams,
    setFilterParam,
    loadMoreUGCReviews,
    setReviewSorting,
    addToFavorites,
    removeFromFavorites,
    getLivePositionData,
    newFacetsSearch: newFacetsSearch as any,
};

export const ShipPage = connect(mapStateToProps, mapDispatchToProps)(ShipPageClass);
export default ShipPage;
